var _title, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingCartBasketItem = function SvgShoppingCartBasketItem(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "shopping-cart-svg")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m936.4 704.6c4.3 1.7 8.2 4.3 11.5 7.6 3.2 3.3 5.9 7.1 7.6 11.4 1.8 4.3 2.8 8.9 2.8 13.5 0 19.5-15.9 35.3-35.3 35.3h-113.3c13.2 17.7 20.6 39.4 20.6 61.7 0 56.6-46 102.6-102.6 102.6-56.6 0-102.6-46-102.6-102.6q0-8.3 1.3-16.5 1.3-8.2 4-16 2.6-7.9 6.5-15.2 3.8-7.4 8.8-14h-161.1c13.2 17.7 20.6 39.4 20.6 61.7 0 56.6-46 102.6-102.6 102.6-56.6 0-102.6-46-102.6-102.6q0-8.3 1.3-16.5 1.3-8.2 4-16 2.6-7.9 6.5-15.2 3.8-7.4 8.8-14h-62.8c-13.4 0-25.5-7.5-31.5-19.4-1.5-2.9-2.6-6-3.2-9.2-0.6-3.1-0.8-6.4-0.6-9.6 0.3-3.3 1-6.4 2.2-9.5 1.1-3 2.7-5.9 4.6-8.5l74.8-122.1-58.1-281.3-23.6-112.2h-125.9c-9.4 0-18.3-3.7-25-10.3-6.6-6.7-10.3-15.6-10.3-25 0-9.4 3.7-18.3 10.3-25 6.7-6.6 15.6-10.3 25-10.3h154.5c16.6 0 31.2 11.8 34.6 28l5.4 25.4 632 2.1q3.8 0 7.5 0.9 3.7 0.8 7.2 2.4 3.4 1.6 6.4 4 3.1 2.3 5.5 5.2c6.6 7.9 9.3 18.3 7.5 28.4l-68.8 385.1c-3 16.6-17.4 28.6-34.2 28.6l-496.8 0.9-29.9 60.9h595.5c4.6 0 9.2 0.9 13.5 2.7zm-563.6-133.1l452.3-0.8 56.4-315.8-575.8-1.9zm41.9 291.8c3.8-1.6 7.3-3.9 10.2-6.9 3-2.9 5.3-6.4 6.9-10.2 1.6-3.8 2.4-8 2.4-12.1 0-17.4-14.2-31.6-31.6-31.6-17.4 0-31.6 14.2-31.6 31.6 0 17.4 14.2 31.6 31.6 31.6 4.1 0 8.3-0.8 12.1-2.4zm325.1 0c3.8-1.6 7.3-3.9 10.2-6.9 3-2.9 5.3-6.4 6.9-10.2 1.6-3.8 2.4-8 2.4-12.1 0-17.4-14.2-31.6-31.6-31.6-17.4 0-31.6 14.2-31.6 31.6 0 17.4 14.2 31.6 31.6 31.6 4.1 0 8.3-0.8 12.1-2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m445 217h42v366h-42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 4",
    className: "s0",
    d: "m445 217h42v366h-42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy",
    className: "s0",
    d: "m584 220h42v366h-42z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s0",
    d: "m295 325h608v52h-608z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 2 copy",
    className: "s0",
    d: "m296 451h608v52h-608z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 3",
    className: "s0",
    d: "m722 229h42v366h-42z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCartBasketItem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart-basket-item.1cca233e.svg";
export { ForwardRef as ReactComponent };